import { render, staticRenderFns } from "./Thesaurus.vue?vue&type=template&id=d1f18822&scoped=true"
import script from "./Thesaurus.vue?vue&type=script&lang=js"
export * from "./Thesaurus.vue?vue&type=script&lang=js"
import style0 from "./Thesaurus.vue?vue&type=style&index=0&id=d1f18822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f18822",
  null
  
)

export default component.exports